import { useNavigate } from "react-router-dom";
import type { Channel } from "@/mocks/streams";
import { formatViewers } from "@/lib/format";

interface HotHostListProps {
  items: Channel[];
}

export default function HotHostList({ items }: HotHostListProps) {
  const navigate = useNavigate();

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-900">
          <span className="w-5 h-5 flex items-center justify-center text-primary-500">
            <i className="ri-fire-line"></i>
          </span>
          热门主播榜
        </h3>
        <span className="text-xs text-foreground-400">按实时人气</span>
      </div>
      <ul className="space-y-1">
        {items.map((channel, index) => (
          <li key={channel.id}>
            <button
              type="button"
              onClick={() => navigate(`/channel/${channel.id}`)}
              className="flex w-full items-center gap-3 rounded-md p-2 text-left transition-colors hover:bg-background-50"
            >
              <span
                className={`w-5 text-center font-heading text-sm font-semibold ${
                  index < 3 ? "text-primary-500" : "text-foreground-400"
                }`}
              >
                {index + 1}
              </span>
              <span className="w-9 h-9 flex-shrink-0 overflow-hidden rounded-full border border-background-300">
                <img src={channel.hostAvatar} alt={`主播 ${channel.hostName}`} className="h-full w-full object-cover" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-1.5">
                  <span className="truncate text-sm text-foreground-800">{channel.hostName}</span>
                  {channel.hostLevel === "签约" && (
                    <span className="rounded bg-accent-500/15 px-1 text-[10px] text-accent-400">签约</span>
                  )}
                </span>
                <span className="block truncate text-xs text-foreground-400">{channel.title}</span>
              </span>
              <span className="flex flex-shrink-0 items-center gap-1 text-xs text-foreground-400">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-eye-line text-xs"></i>
                </span>
                {formatViewers(channel.viewers)}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}